import React from 'react';

import { Button, Stack, useMantineTheme } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import PaymentMethodSelect from 'components/form-fields/auto-complete-fields/PaymentMethodSelect';
import SharedPaymentMethodsAlert from 'components/SharedPaymentMethodsAlert';
import { useAuth } from 'context/auth-context';
import useAthleteIsSharingPaymentMethods from 'hooks/athlete/useAthleteIsSharingPaymentMethods';

import { useCheckout } from '../../CheckoutContext';

interface SelectPaymentMethodProps {
  onAddPaymentMethod: () => void;
}

const SelectPaymentMethod = ({ onAddPaymentMethod }: SelectPaymentMethodProps): JSX.Element => {
  const theme = useMantineTheme();
  const { session } = useAuth();
  const { form } = useCheckout();

  const isSharingPaymentMethods = useAthleteIsSharingPaymentMethods(session?.athlete?.athleteId);

  return (
    <Stack spacing='sm'>
      <PaymentMethodSelect
        withinPortal
        required
        placeholder='Select a payment method'
        athleteId={session?.athlete?.athleteId}
        useDefaultPayment
        notFoundMessage='No payment methods found'
        {...form.getInputProps('paymentMethod.selectedPaymentMethodId')}
      />
      <Button
        leftIcon={<IconPlus size={theme.fontSizes.sm} />}
        w='fit-content'
        variant='subtle'
        data-cy='addPaymentMethodButton'
        onClick={onAddPaymentMethod}
      >
        Add Payment Method
      </Button>
      {isSharingPaymentMethods && <SharedPaymentMethodsAlert sx={{ marginBottom: '1rem' }} />}
    </Stack>
  );
};

export default SelectPaymentMethod;
